import { io } from "socket.io-client";

// const dev = `http://localhost`;
const dev = process.env.REACT_APP_JOSHUA == "true" ? 'http://localhost' : process.env.REACT_APP_GAME_SERVER_URL;
const prod = process.env.REACT_APP_GAME_SERVER_URL;

const URL = process.env.NODE_ENV === "development" ? dev : prod;

const socket = io(URL + '/chess', {
    autoConnect: false,
    path: '/games/socket.io'
});

export default socket;